import Footer from "./Footer";
import Header from "./Header";
import CookieConsent from "../common/CookieConsent";

const MainContainer = ({
  children,
  className,
  childrenClassName,
  hideHeader = false,
  hideFooter = false,
}) => {
  return (
    <div className={`w-full ${className}`}>
      {!hideHeader && <Header />}
      <main className={childrenClassName}>{children}</main>
      {!hideFooter && <Footer />}
      <CookieConsent />
    </div>
  );
};

export default MainContainer;
